import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppTableComponent, Form, FormElement, MessagesComponent, RequestsService, TaskModel, TranslationManager, ViewState
} from 'src/common';
import { Location } from '@angular/common';
import { TaskSelectComponent } from 'src/views/components/task-select';
import { OrganizationalUnitSelectComponent } from 'src/views/components/organizational-unit-select';
import { OrganizationalUnitModel } from 'src/common/services/organizational-unit';
import { OpnProjectDeadlineListDetailsModel, OpnProjectDeadlineListSaveModel, OpnProjectDeadlineListViewModel, OpnProjectDeadlinesListService } from 'src/common/services/requests/opn-steps/opn-projectdeadlines-list';

@Component({
  selector: 'opn-projectdeadline-list',
  templateUrl: 'opn-projectdeadline-list.component.html'
})

export class OpnProjectDeadlineListComponent implements OnInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("taskSelectComponent") taskSelectComponent: TaskSelectComponent;
  @ViewChild("organizationalUnitSelectComponent") organizationalUnitSelectComponent: OrganizationalUnitSelectComponent;

  state: ViewState;
  viewState = ViewState;

  requestId: number;
  form: Form = new Form();

  taskId: number;
  organizationalUnitModelid: number;
  opnProjectDeadlineListSaveModelId: number;
  selectDisplaysToSuppliersId: boolean;
  translationManager = TranslationManager;

  show: boolean = false;
  resolve: any;
  isDeadlineForCompletionRequired: boolean;
  isEdit: boolean;

  constructor(
    private requestsService: RequestsService,
    private service: OpnProjectDeadlinesListService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location) {
  }

  ngOnInit(): void {
    this.initForm();
  }


  private initForm(): void {
    this.form.elements["name"] = new FormElement();
    this.form.elements["name"].state.mandatory = true;
    this.form.elements["description"] = new FormElement();
    this.form.elements["description"].state.mandatory = true;
    this.form.elements["deadlineForCompletion"] = new FormElement();
    this.form.elements["deadlineForCompletion"].state.mandatory = true;
    this.form.elements["organizationalUnitName"] = new FormElement();
    this.form.elements["organizationalUnitName"].state.mandatory = true;
  }

  private mapModelToFormCreate(): void {
    this.form.elements["name"].value = '';
    this.form.elements["description"].value = '';
    this.form.elements["deadlineForCompletion"].value = '';
    this.form.elements["organizationalUnitName"].value = '';
  }

  private mapModelToForm(item: OpnProjectDeadlineListDetailsModel): void {
    let deadlineForCompletion = this.formatDate(new Date(item.deadlineForCompletion));
    this.opnProjectDeadlineListSaveModelId = item.id;
    this.taskId = item.taskId;
    this.form.elements["name"].value = item.taskName;
    this.form.elements["description"].value = item.description;
    this.form.elements["deadlineForCompletion"].value = deadlineForCompletion;
    this.form.elements["organizationalUnitName"].value = item.organizationalUnitName;
    this.organizationalUnitModelid = item.organizationalUnitId;
    this.selectDisplaysToSuppliersId = item.displaysToSuppliers;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  selectTask() {
    this.taskSelectComponent.showModal(this.requestId).then((model: TaskModel) => {
      if (model != undefined) {
        this.taskId = model.id;
        this.form.elements["name"].value = model.name;
        this.form.elements["description"].value = model.description;
      }
    });
  }

  selectOrganizationalUnit() {
    this.organizationalUnitSelectComponent.showModal().then((model: OrganizationalUnitModel) => {
      if (model != undefined) {
        this.organizationalUnitModelid = model.id;
        this.form.elements["organizationalUnitName"].value = model.name;
      }
    });
  }

  selectDisplaysToSuppliers(event) {
    this.selectDisplaysToSuppliersId = event.target.checked;
  }


  showModal(): Promise<boolean> {
    this.show = true;
    this.isDeadlineForCompletionRequired = false;

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  createModal(requestId:number): Promise<boolean> {
    this.state=ViewState.Create;
    this.requestId=requestId;
    this.selectDisplaysToSuppliersId = false;
    this.opnProjectDeadlineListSaveModelId =null;

    this.mapModelToFormCreate();

    return this.showModal();
  }

  editModal(item: OpnProjectDeadlineListViewModel,requestId:number): Promise<boolean> {
    this.state=ViewState.Edit;
    this.requestId=requestId;
    this.opnProjectDeadlineListSaveModelId =null;
    this.service
        .getById(item.id)
        .then((item: OpnProjectDeadlineListDetailsModel) => {
          this.mapModelToForm(item);
        });

    return this.showModal();
  }

  close() {
    this.show = false;
    if (this.resolve) {
      this.resolve(false);
    }
  }

  submit() {

    if (this.form.isValid() && !this.isDeadlineForCompletionRequired) {
      let model: OpnProjectDeadlineListSaveModel = new OpnProjectDeadlineListSaveModel();
      model.id = this.opnProjectDeadlineListSaveModelId;
      model.requestId = Number(this.requestId);
      model.taskId = this.taskId;
      model.deadlineForCompletion = this.form.elements["deadlineForCompletion"].value;
      model.organizationalUnitId = this.organizationalUnitModelid;
      model.displaysToSuppliers = this.selectDisplaysToSuppliersId;

      this.service.save(model).then(() => {
        this.show = false;
        if (this.resolve) {
          this.resolve(true);
        }
      }).catch((reason: any) => {
        MessagesComponent.instance.showError([reason.error.messages]);
      });

    }
    else{
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Морате прво попунити сва обавезна поља.')]);
    }
  }

  navigateToList() {
   this.location.back();
  }

}
